import { DateUtil } from '@src/packages/utils/dates';
import { ATTENDANCE_EVENT_TYPE } from '@src/packages/workJourney/constants';

import type { MarkAttendanceConfirmKind, MarkAttendanceJourneyDetails } from '../types';

export const SHIFT_END_EARLY_MINUTES = 30;

export const isShiftEndEarlierThanScheduled = ({
  kind,
  markedAt,
  journeyDetails,
}: {
  kind: MarkAttendanceConfirmKind | null;
  markedAt: Date | null;
  journeyDetails: MarkAttendanceJourneyDetails | null;
}): boolean => {
  if (kind !== ATTENDANCE_EVENT_TYPE.SHIFT_END || !markedAt || !journeyDetails) {
    return false;
  }

  if (journeyDetails.scheduledEndAtSeconds == null) {
    return false;
  }

  const scheduledEndMs = DateUtil.toDate(journeyDetails.scheduledEndAtSeconds).getTime();
  const earlyWindowMs = SHIFT_END_EARLY_MINUTES * 60 * 1000;

  return scheduledEndMs - markedAt.getTime() >= earlyWindowMs;
};
